import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { DrawerCSSProvider } from "./pages/routing/providers/drawer-css-provider.tsx";
import LanguageProvider from "./pages/routing/providers/language.provider.tsx";
import { Toaster } from "./components/ui/toaster.tsx";
import CookieConsent from "@/shared/popup/cookie-consent";
import LoadingSpinner from "./shared/components/loading-spinner.tsx";
import "maplibre-gl/dist/maplibre-gl.css";
import "./index.css";
import router from "./pages/routing/router.tsx";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Route events through dev server in development to avoid CORS
  tunnel: import.meta.env.DEV ? "/sentry-tunnel" : undefined,
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <DrawerCSSProvider>
      <LanguageProvider>
        <Suspense fallback={<LoadingSpinner />}>
          <RouterProvider router={router} />
        </Suspense>
        <Toaster />
        <CookieConsent />
      </LanguageProvider>
    </DrawerCSSProvider>
  </StrictMode>,
);
